<div class="actions__buttons">
    <button type='button' mat-button class="actions__cancel" (click)="cancel()">
        {{ "auth.fields.submit.cancel" | translate }}
    </button>
    <button type="button" mat-raised-button class="actions__login" (click)="submit($event)">
        <div class="actions__login-inside">
            <span>{{ "auth.fields.submit.login" | translate }}</span>
            <mat-icon aria-hidden="false" aria-label="login icon" svgIcon="user"></mat-icon>
        </div>
    </button>
</div>
<div class="actions__no_account">
    <span class="no_account_text">{{ "auth.fields.no_account" | translate }}</span>
    <button mat-button class="no_account_button" (click)="goToSignup()">{{ "auth.fields.no_account_button" | translate}}</button>
</div>
